export const REQUEST_PLAY_TRACK = "request:play:track"

export const RESPONSE_ALBUM_LOADED = "response:album:loaded"

export const CODE_CHANGED = "code:changed"
